import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {UserPermissionManager} from './user-permission';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';

class CpqCustomerPermissionClass implements UserPermission {
  readonly userRole = UserRole.CPQ_CUSTOMER;
  readonly labelRole = 'Customer';
  readonly isAuthenticated = true;

  readonly canRequestEto = false;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = false;
  readonly canSeeHisAccountInRightDrawer = true;
  readonly canSeeHisAccountPreferences = false;
  readonly canHaveManyEditableProforma = true;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = false;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = false;
  readonly crmSectionsVisible = [];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = [];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [];
  readonly visibleUserAreaColumns = [];

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = false;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = true;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = false;
  readonly canDownloadPackingList = false;
  readonly canSeeConfigurationList = false;
  readonly canSeeCustomerConfigurationTab = false;
  readonly canSeeSummaryRecap = true;
  readonly canEditProbability = false;

  readonly composerAllowed = true;
}

const CpqCustomerPermission = new CpqCustomerPermissionClass();

UserPermissionManager.instance.assignPermissionForRole(CpqCustomerPermission);
